// Application Pixi DUY NHẤT (TECH_BASELINE §5.1, Bất biến 9: chỉ 1 WebGL context).
// Canvas là con trực tiếp của <body>, nằm dưới lớp DOM; CSS lo phép cover.
import { Application, Program, getTestContext } from 'pixi.js';
import { PIXI_COLORS } from '@ui/tokens';

export const FRAME_W = 390;
export const FRAME_H = 844;
export const MAX_DPR = 2;

let app: Application | null = null;

export function createStage(host: HTMLElement = document.body): Application {
  if (app) throw new Error('stage already created: only one Pixi Application is allowed');
  const a = new Application({
    width: FRAME_W,
    height: FRAME_H,
    backgroundColor: PIXI_COLORS.bgDeep,
    antialias: false,
    resolution: Math.min(window.devicePixelRatio || 1, MAX_DPR),
    autoDensity: false,
    powerPreference: 'high-performance',
  });
  const view = a.view as HTMLCanvasElement;
  view.id = 'game-canvas';
  view.setAttribute('aria-hidden', 'true');
  host.insertBefore(view, host.firstChild);
  releaseTestContext();
  app = a;
  return a;
}

/**
 * Pixi 7 dò độ chính xác fragment shader bằng một context WebGL THỬ riêng (getTestContext) rồi giữ nó
 * sống suốt đời app. Ép phép dò chạy một lần (kết quả được cache ở cấp module) rồi hủy context thử,
 * để cả app chỉ còn đúng 1 WebGL context (Bất biến 9).
 */
function releaseTestContext(): void {
  Program.from('void main(){gl_Position=vec4(0.0);}', 'void main(){gl_FragColor=vec4(0.0);}');
  const gl = getTestContext();
  gl?.getExtension('WEBGL_lose_context')?.loseContext();
}

export function stage(): Application | null {
  return app;
}

/**
 * Dừng / chạy lại scene màn hình. Khi cửa sổ, trang con hay dải hỏi phủ lên (nền mờ + blur), scene
 * gần như không nhìn thấy: không update, không vẽ lại (TECH_BASELINE §5.1 "scene không nhìn thấy thì
 * không update"). Vỏ DOM vẫn chạy 60fps; khung canvas cuối cùng được giữ nguyên dưới lớp phủ.
 */
export function setScenePaused(paused: boolean): void {
  if (!app) return;
  if (paused && app.ticker.started) app.ticker.stop();
  else if (!paused && !app.ticker.started) app.ticker.start();
}
